import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
// styles
import './FarmFeedHiddenPosts.scss';

// Inline indicator for posts hidden by the "only tagged posts" preference, toggles them in place
const FarmFeedHiddenPosts = ({ count, isExpanded, onToggle }) => (
  <div className="FarmFeedHiddenPosts">
    <button type="button" className="hidden-posts-toggle" onClick={onToggle}>
      <i className={`fa fa-angle-${isExpanded ? 'up' : 'down'} mr-5`} />
      <FormattedMessage
        id={`container.farmfeed.hiddenPosts.${isExpanded ? 'hide' : 'show'}`}
        values={{ count }}
      />
    </button>
  </div>
);

FarmFeedHiddenPosts.propTypes = {
  count: T.number.isRequired,
  isExpanded: T.bool.isRequired,
  onToggle: T.func.isRequired,
};

export default FarmFeedHiddenPosts;
